import clsx, { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

import { merge } from "../types/Merge";

export const cn = (...classes: ClassValue[]) => twMerge(clsx(classes));

export type { ClassValue } from "clsx";
export type withCN<props extends object> = merge<[props, { className: ClassValue }]>;
